<template>
    <modal
        :id="id"
        :actionButtons="false"
        size="lg"
        :closeButton="true"
        @shown="shown() "
    >
        <template slot="modal-header">
            <span></span>
        </template>
        <preset-treatment-browser :use-treatment="useTreatmentClose" :use-preset="usePresetClose"></preset-treatment-browser>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Money from "@/components/Money.vue";
import SpecialtyNav from '@/components/SpecialtyNav'
import { modalMixins } from '@/mixins/modal.js'
import { mapGetters, mapState, mapActions } from 'vuex';
import { icdMixins } from '@/components/ICD10/icd-mixins.js';
import duration from '@/filters/duration.js';
import PresetTreatmentBrowser from "@/components/PresetTreatmentBrowser";

export default {
    name: 'PTBrowserModal',
    props: {
        id: String,
        usePreset: Function,
        useTreatment: Function
    },
    mixins: [modalMixins, icdMixins],
    filters: { duration },
    components: {
        PresetTreatmentBrowser,
        Money,
        Modal,
        SpecialtyNav
    },
    data() {
        return {}
    },
    computed: {},

    methods: {
        ...mapActions('users', { updateUser: 'patch' }),

        usePresetClose(item) {
            this.usePreset(item)
            this.close()
        },

        useTreatmentClose(item) {
            this.useTreatment(item)
            this.close()
        },

        close() {
            this.$root.$emit('bv::hide::modal', this.id);
        },

        shown() {
        },
    },

}
</script>
<style>
.pre-formatted {
    white-space: pre;
}
</style>
